export default function formatBeverlyWilshireSubstr(name) {
	if (name.indexOf('Beverly Wilshire, A Four Seasons Hotel') >= 0) {
		return name.replace(
			'A Four Seasons Hotel',
			`<span class="font-20">A Four Seasons Hotel</span>`
		);
	}
	return name;
}
